export default {
  SERVICES(state, data) {
    state.services        = data;
    state.servicesLoading = false;
  },

  SERVICES_CONVERT(state, data) {
    for (const specialist of state.services) {
      for (const service of specialist.services) {
        if (service.id === data) {
          specialist.services_count = specialist.services_count - 1;

          if (specialist.services.length === 1) {
            if (state.services.length === 1) {
              state.services = [];
              return;
            }

            state.services = state.services.filter(
              (s) => s.id !== specialist.id
            );
          }

          specialist.services = specialist.services.filter(
            (service) => service.id !== data
          );

          return;
        }
      }
    }
  },

  SERVICES_METADATA(state, data) {
    state.servicesBreak    = parseInt(data.standard_break_duration);
    state.servicesDuration = parseInt(data.standard_service_duration);
  },

  SERVICES_APPEARANCE(state, data) {
    state.servicesAppearance = data;
  },
}
